import api from "../libs/api";

export default {
  lang: api.LANG,
  isloading: false,
  path: "Home"
} 